import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-modale" }
const _hoisted_2 = { class: "texte center" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('home.modale.authentication.header')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.modale.authentication.label')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          class: "margin-10px width-input"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            onClick: _ctx.registerMail,
            text: _ctx.$t('home.modale.authentication.button'),
            class: "button"
          }, null, 8, ["onClick", "text"])
        ])
      ])
    ]),
    _: 1
  }))
}